import { Skeleton } from '@mui/material';

export const CostOverviewLoader = (): JSX.Element => {
  return <Skeleton variant="text" width={'109px'} height={'2.13rem'} />;
};
